<template>
  <div
    class="itinerary-edit"
    @scroll="onScroll"
  >
    <div class="from-to">
      <div
        class="retur-trip-toggle-container"
        v-if="!udSelected"
      >
        <Toggle
          v-model="returTripActive"
          @toggle="onReturTripActiveToggle"
        />
        <span>Returrejse er slået</span>
        <span v-if="returTripActive">&nbsp;til</span>
        <span v-else>&nbsp;fra</span>
      </div>
      <template v-if="udSelected || returTripActive">
        <TimeContainer
          :startTime="startTime"
          :onEditClick="onTimeEditClick"
        />
        <div class="dots">
          <Place
            :place="fromPlace"
            :toggleEditMode="this.toggleFromPlaceEditMode"
            :editMode="this.editMode==='fromPlace'"
            :searchResultSelected="this.fromPlaceSelected"
            :placeType="'udgangspunkt'"
          />
          <Transport
            :modes="transportModes"
            :toggleTransportMode="toggleTransportMode"
            :tripType="tripType"
            :viaPlace="viaPlace"
            :removeCycleTo="removeCycleTo"
            :placeType="'startsted'"
            :walkReluctance="walkReluctance"
            :setWalkReluctance="setWalkReluctance"
          />
          <Place
            :place="toPlace"
            :toggleEditMode="this.toggleToPlaceEditMode"
            :editMode="this.editMode==='toPlace'"
            :searchResultSelected="this.toPlaceSelected"
            :placeType="'destination'"
          />
        </div>
      </template>
      <div
        v-else
        class="filler"
      ></div>
    </div>
    <div
      v-if="itineraries.length"
      class="itineraries-bg"
      id="scrollTarget"
    >
      <div class="itineraries-box">
        <div class="itineraries-tabs">
          <ItineraryTab
            v-for="(itinerary, index) in itineraries"
            :key="index"
            :selected="index === selectedItineraryIndex"
            :itinerary="itinerary"
            @click.native="onItineraryClick(index)"
          />
        </div>
        <CurrentItinerary
          v-if="selectedItineraryIndex > -1"
          :itinerary="currentItinerary"
          :fromPlace="fromPlace"
          :toPlace="toPlace"
        />
      </div>
      <a
        href="http://www.septima.dk"
        target="_blank"
        class="septima-logo"
      >
        <SeptimaLogo :iconColor="'#101B70'" /></a>
    </div>

    <ScrollDownButton
      v-if="shouldShowScrollButton"
      :onClick="scrollDown"
    />
    <a
      href="http://www.septima.dk"
      target="_blank"
      class="septima-logo"
    >
      <SeptimaLogo :iconColor="'#101B70'" /></a>
  </div>
</template>

<script>
import { Settings } from 'luxon';
import ItineraryTab from '@/components/Itinerary/ItineraryTab';
import CurrentItinerary from '@/components/Itinerary/CurrentItinerary';
import Place from '@/components/Itinerary/Place';
import TimeContainer from '@/components/Itinerary/TimeContainer';
import Transport from '@/components/Itinerary/Transport';
import Toggle from '@/components/common/Toggle';
import ScrollDownButton from '@/components/Itinerary/ScrollDownButton';
import SeptimaLogo from '@/components/Icons/SeptimaLogo.vue';
export default {
  name: 'itinerary-edit',
  components: {
    CurrentItinerary,
    ItineraryTab,
    Place,
    TimeContainer,
    Transport,
    Toggle,
    ScrollDownButton,
    SeptimaLogo,
  },
  props: {
    itineraries: Array,
    selectedItineraryIndex: Number,
    selectItinerary: Function,
    fromPlace: Object,
    toPlace: Object,
    onTimeEditClick: Function,
    startTime: String,
    toggleEditMode: Function,
    editMode: String,
    fromPlaceSelected: Function,
    toPlaceSelected: Function,
    transportModes: Object,
    toggleTransportMode: Function,
    tripType: String,
    viaPlace: Object,
    removeCycleTo: Function,
    walkReluctance: Number,
    setWalkReluctance: Function,
    udSelected: Boolean,
    returTripActive: Boolean,
    onReturTripActiveToggle: Function,
  },
  data: function() {
    return {
      shouldShowScrollButton: false,
    };
  },
  methods: {
    scrollDown() {
      let element = document.getElementById('scrollTarget');
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    onScroll(e) {
      const { target } = e;
      if (!this.itineraries.length || target.scrollTop > 200) {
        this.shouldShowScrollButton = false;
      } else {
        this.shouldShowScrollButton = true;
      }
    },
    toggleFromPlaceEditMode() {
      this.toggleEditMode('fromPlace');
    },
    toggleToPlaceEditMode() {
      this.toggleEditMode('toPlace');
    },
    onItineraryClick(index) {
      this.selectItinerary(index);
    },
  },
  computed: {
    currentItinerary() {
      if (this.selectedItineraryIndex < 0) {
        return undefined;
      }
      return this.itineraries[this.selectedItineraryIndex];
    },
  },
  watch: {
    itineraries: function(itineraries) {
      if (itineraries.length && this.$el.scrollTop < 200) {
        this.shouldShowScrollButton = true;
      } else {
        this.shouldShowScrollButton = false;
      }
    },
  },
  mounted() {
    Settings.defaultLocale = 'da';
  },
};
</script>

<style lang="scss" scoped>
.itinerary-edit {
  flex-grow: 1;
  flex-basis: 0;
  background-color: $primary-100;
  margin-right: 2px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.from-to {
  padding: 10px 0;
}

.itineraries-bg {
  flex: 1;
  border-top: 5px solid rgba(122, 129, 176, 0.1);
  background-color: $primary-300;
}
.itineraries-box {
  margin: 26px 60px 20px 80px;
  border-radius: 6px;
  background-color: $primary-100;
  display: flex;
}
.itineraries-tabs {
  width: 170px;
  display: flex;
  flex-direction: column;
}

#get-more-container {
  padding: 8px;
  border-top: 3px solid #dedfef;
}

.dots {
  position: relative;
}

.dots:after,
.dots:before {
  content: '';
  position: absolute;
}

.dots:before {
  top: 65px;
  left: 38px;
  bottom: 80px;
  border-width: 0 0 0 5px;
  border-style: dotted;
  border-color: #9197be;
}

.dots:after {
  background: url('../../assets/dotsArrow.svg') no-repeat center;
  display: block;
  height: 13px;
  width: 13px;
  bottom: 62px;
  left: 34px;
  background-size: 100%;
}

.retur-trip-toggle-container {
  display: flex;
  align-items: center;
  margin: 10px 80px;
  :nth-child(2) {
    margin-left: 20px;
  }
}
.filler {
  height: 70vh;
}

.septima-logo {
  display: block;
  opacity: 0.3;
  align-self: center;
  padding: 20px 0;
  text-align: center;
}

.itineraries-bg ~ .septima-logo {
  display: none;
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  .itinerary-edit {
    width: 100%;
    height: 100%;
    // min-height: 100%;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    margin-right: 0;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  .itineraries-tabs {
    // display: none;
    width: 100%;
  }

  .dots:before {
    left: 28px;
    top: 58px;
    bottom: 72px;
  }

  .dots:after {
    bottom: 55px;
    left: 24px;
  }

  .itineraries-box {
    background-color: transparent;
    margin: 26px 30px;
    flex-direction: column;
  }

  #get-more-container {
    padding: 0;
    border-top: none;
  }

  .retur-trip-toggle-container {
    margin: 20px 30px 10px 60px;
  }

  .filler {
    height: 50vh;
  }

  .septima-logo {
    //   align-self: start;
    //   text-align: left;
    //   padding-left: 30px;
    padding: 10px 0 30px 0;
  }
}
</style>
